import React from 'react';
import Pic from 'components/Helpers/Pic/Pic';
import Bildtext from 'components/Helpers/Bildtext/Bildtext';

const Bild = props => {
  const style = require('./Bild.scss');
  var { id, fil, storlek, bildtext, foto, credit, alt, imgix, preload, size, capstyle} = props;
  const ratios = {
    s: 'wide',
    m: 'cinema,imax',
    l: 'wide,cinema',
    xl: 'square,wide',
    full: 'portrait,wide',
    square: 'square',
    normal: 'normal',
    wide: 'wide',
    lwide: 'wide',
    xlwide: 'wide',
    cinema: 'cinema',
    xlcinema: 'cinema',
    portrait: 'portrait',
    imax: 'imax',
    imaxfull:'imax',
    balk: 'balk',
    smalis: 'smalis'
  };
  const storlek_ratio = (storlek && storlek.toLowerCase() in ratios && storlek.toLowerCase()) || 'l';
  var picProps = {
    id: id || fil,
    source: (id && "escenic") || (fil && "imgix"),
    title: bildtext,
    altText: alt,
    ratio: ratios[storlek_ratio],
    className: style[storlek_ratio],
    version: "1",
    imgixSettings: imgix,
    preload: !!preload,
    size: size
  };

  return (
      <Pic {...picProps}>
        <Bildtext text={bildtext} foto={foto} credit={credit} style={capstyle}/>
      </Pic>
  );
};

export default Bild;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/Bild/Bild.js
 **/